import { createStructuredSelector, createSelector } from 'reselect';
import { userIdSelector } from 'swag-client-common/redux/user/user.selectors';
import { pageSelector, pageLoadedSelector, lastPageSelector, isLoadingSelector, erroredSelector, isProductsListFetchedSelector, subcategoriesSelector, productsSelector } from '../../../../../../../redux/product-listing/product-listing.selectors';
export const infiniteProductsSelector = createStructuredSelector({
  page: pageSelector,
  lastPage: lastPageSelector,
  isLoading: isLoadingSelector,
  errored: erroredSelector,
  shouldLoadMore: createSelector(pageSelector, pageLoadedSelector, lastPageSelector, isLoadingSelector, erroredSelector, productsSelector, (page, pageLoaded, lastPage, isLoading, errored, products) => page < lastPage && !(page === pageLoaded && products.length === 0) && !isLoading && !errored),
  isProductsListFetched: isProductsListFetchedSelector,
  subcategories: subcategoriesSelector,
  products: productsSelector,
  isLoggedIn: userIdSelector
});